import { useMemo } from "react"
import { useSelector } from "react-redux"
import { LevelSettingType } from "@/api/FacilityLevelsService"
import { RootState } from "@/store"
import { formatLevelSettings } from "@/utils/facilities"

export function useFastAlarmClearanceEnabled(): boolean {
   const { facilityDetails } = useSelector(
      ({ facilitiesReducer }: RootState) => facilitiesReducer
   )

   return useMemo(() => {
      const settings = facilityDetails.settings
      if (!settings || settings.length === 0) {
         return false
      }
      return !!formatLevelSettings(settings)[
         LevelSettingType.ALARM_FAST_CLEARANCE_ENABLED
      ]
   }, [facilityDetails.settings])
}
